/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { miscGetHistoryProgrammer } from "../../funcs/miscGetHistoryProgrammer.js";
import { GetHistoryProgrammerRequest$zodSchema } from "../../models/gethistoryprogrammerop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetHistoryProgrammerRequest$zodSchema,
};

export const tool$miscGetHistoryProgrammer: ToolDefinition<typeof args> = {
  name: "misc-get-history-programmer",
  description: `程序员历史事件

想查看程序员历史上某个特定日期发生的大事件？指定月份和日期，我们就能告诉你！

## 功能概述
通过指定月份和日期，获取该日发生的程序员相关历史事件。同样使用AI智能筛选，确保事件的相关性和重要性。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await miscGetHistoryProgrammer(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
